// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  //  production: false
  production: true,

  //we have new backend deployemnt url
   // apiUrl: 'https://edvac-api.edwardsvacuum.com/api',    //we have new backend deployemnt url
 apiUrl: 'https://wa-p-10010471-002-gea5f0evfhadczdh.southeastasia-01.azurewebsites.net/api', // Production
           
//  apiUrl:'http://localhost:44306/api'       
 
  // apiUrl: 'https://krios-growvac.azurewebsites.net/api',
//apiUrl: 'https://krios-growvac-uat.azurewebsites.net/api',
  
//apiUrl: 'https://krios-growvac.azurewebsites.net/api',    //localhost
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
